import { createSlice } from '@reduxjs/toolkit';
import { getProducts, getTotalProducts, loadMoreProducts } from './thunks';

const giftingCategoryDetailSlice = createSlice({
  name: 'giftingCategoryDetail',
  initialState: {
    products: [],
    totalProducts: '...',
    status: {
      products: 'idle',
      totalProducts: 'idle',
      loadMoreProducts: 'idle',
    },
  },
  reducers: {
    setState(state, { value, name }) {
      state[name] = value;
    },
    setStatusApi(state, { value, name }) {
      state.status[name] = value;
    },
    resetState(state) {
      state.products = [];
      state.totalProducts = '...';
      state.status = {
        products: 'idle',
        totalProducts: 'idle',
        loadMoreProducts: 'idle',
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.status.products = 'loading';
      })
      .addCase(getProducts.rejected, (state) => {
        state.status.products = 'error';
      })
      .addCase(getProducts.fulfilled, (state, { payload }) => {
        state.products = payload.data;
        state.status.products = 'succeeded';
      })
      .addCase(getTotalProducts.pending, (state) => {
        state.status.totalProducts = 'loading';
      })
      .addCase(getTotalProducts.rejected, (state) => {
        state.status.totalProducts = 'error';
      })
      .addCase(getTotalProducts.fulfilled, (state, { payload }) => {
        state.totalProducts = payload.data;
        state.status.totalProducts = 'succeeded';
      })
      .addCase(loadMoreProducts.pending, (state) => {
        state.status.loadMoreProducts = 'loading';
      })
      .addCase(loadMoreProducts.rejected, (state) => {
        state.status.loadMoreProducts = 'error';
      })
      .addCase(loadMoreProducts.fulfilled, (state, { payload }) => {
        const existingIds = new Set(
          state.products.map((product) => product._id || product.id),
        );
        const newUniqueProducts = payload.data.filter(
          (product) => !existingIds.has(product._id || product.id),
        );
        state.products = [...state.products, ...newUniqueProducts];
        state.status.loadMoreProducts = 'succeeded';
      });
  },
});

export default giftingCategoryDetailSlice.reducer;
